import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable } from "ui";

import { DamagedItemsListItem } from "../../inventory.types";
import { InventoryProductVariant } from "../InventoryProductVariant";
import { DamageImageCell, OrderBoxCell, ShowBtnCell } from "./atoms";
import { DamagedItemsTableProps } from "./DamagedItemsTable.types";

import styles from "./DamagedItemsTable.module.scss";

const DamagedItemsTable = ({
  damagedItems,
  sorting,
  setSorting,
  isLoading,
  onShowDamagedItem
}: DamagedItemsTableProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const columns: Array<
    ColumnDef<DamagedItemsListItem, DamagedItemsListItem[]>
  > = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: t("Item"),
        size: 22,
        minSize: 22,
        cell: ({ row }) => (
          <InventoryProductVariant
            productVariant={damagedItems[row.index].productVariant}
          />
        )
      },
      {
        header: t("Related to"),
        enableSorting: false,
        size: 11,
        minSize: 11,
        cell: ({ row }) => (
          <OrderBoxCell
            orderId={damagedItems[row.index].orderId}
            boxId={damagedItems[row.index].inventoryBoxId}
          />
        )
      },
      {
        header: t("Buying Price"),
        accessorKey: "BuyingPrice",
        size: 11,
        minSize: 11,
        cell: ({ row }) => (
          <pre>{damagedItems[row.index].productVariant.buyingPrice}</pre>
        )
      },
      {
        header: t("Date of notice"),
        accessorKey: "DamagedDate",
        size: 11,
        minSize: 11,
        cell: ({ row }) => (
          <pre>
            {damagedItems[row.index].damagedAt ? (
              <>
                {`${moment(damagedItems[row.index].damagedAt).format("DD/MM/YYYY")}`}
                {"\n"}
                {`${moment(damagedItems[row.index].damagedAt).format("HH:mm")}`}
              </>
            ) : (
              "-"
            )}
          </pre>
        )
      },
      {
        header: t("Manager’s note & picture"),
        enableSorting: false,
        size: 18,
        minSize: 18,
        cell: ({ row }) => damagedItems[row.index].damageDescription
      },
      {
        id: "photo",
        header: "",
        enableSorting: false,
        size: 6,
        minSize: 6,
        cell: ({ row }) => (
          <DamageImageCell mediaFile={damagedItems[row.index].damageImage} />
        )
      },
      {
        header: t("Item link"),
        enableSorting: false,
        size: 7,
        minSize: 7,
        cell: ({ row }) => (
          <ShowBtnCell
            onClick={() => onShowDamagedItem(damagedItems[row.index].id)}
          />
        )
      }
    ],
    [damagedItems, currentLanguage]
  );

  return (
    <ItemsTable
      className={styles.damagedItemsTable}
      columns={columns}
      data={damagedItems}
      sorting={sorting}
      skeletonHeight={135}
      setSorting={setSorting}
      isLoading={isLoading}
    />
  );
};

export default DamagedItemsTable;
